import React from 'react';
import CodeIcon from '@heroicons/react/outline/CodeIcon.js';
import { BlockType } from '../../types/index.js';
import { HtmlScriptBlock as Component } from './Block.js';
import { HtmlScriptBlockSettings as Settings } from './Settings.js';
export const RegisteredHtmlScriptBlock = (intl) => {
    const { $t } = intl;
    return {
        recommendedName: 'HtmlScript',
        Component,
        config: {
            type: BlockType.Block,
            usable: true,
            displayName: $t({
                id: 'Blocks.HtmlScript.DisplayName',
                defaultMessage: 'Html Script',
            }),
            Settings,
            Icon: React.createElement(CodeIcon, null),
            defaultProps: {
                html: '',
                wrapper: 'card-with-padding',
            },
        },
    };
};
//# sourceMappingURL=registered.js.map